import React from 'react';
import PropTypes from 'prop-types';
import { useLocalisation } from '@3plearning/lingui-cdn';
import moment from 'moment';

import { ASSIGNMENT_RESULT_TYPES } from '@helpers/constants';
import { isDefined } from '@helpers/utils';

import getTranslations from './translations';

import { Root, Circle, ConnectBlock, ToolTipWrapper, AssignInfo, AccuracyInfo } from './styled';

const Attempt = ({ attempt }) => {
  const { assignmentType, assignedOn, isCurrentlyAssigned, resultAccuracy, isFocusedResult } = attempt;

  const { i18n } = useLocalisation();
  const { ASSIGNED_TEXT, VOLUNTARY_TEXT, CURRENT_ASSIGNED_TEXT } = getTranslations({ i18n });

  /**
   * Functions
   */
  const getAssignText = () => {
    if (isCurrentlyAssigned) return CURRENT_ASSIGNED_TEXT;

    const assignTypeTexts = {
      [ASSIGNMENT_RESULT_TYPES.ASSIGNED]: ASSIGNED_TEXT,
      [ASSIGNMENT_RESULT_TYPES.VOLUNTARY]: VOLUNTARY_TEXT
    };

    return assignTypeTexts[assignmentType] || ASSIGNED_TEXT;
  };

  /**
   * Local Variables
   */
  const assignedText = getAssignText();
  const formattedDate = assignedOn ? moment(assignedOn).format('DD/MM/YY') : '';
  const hasAccuracyResult = isDefined(resultAccuracy);

  return (
    <Root>
      <Circle isFocusedResult={isFocusedResult} resultAccuracy={resultAccuracy} />
      <ConnectBlock />
      <ToolTipWrapper>
        <AssignInfo hasAccuracyResult={hasAccuracyResult}>{`${assignedText} ${formattedDate}`}</AssignInfo>
        <AccuracyInfo resultAccuracy={resultAccuracy} hasAccuracyResult={hasAccuracyResult}>
          {hasAccuracyResult && `${resultAccuracy}%`}
        </AccuracyInfo>
      </ToolTipWrapper>
    </Root>
  );
};

Attempt.propTypes = {
  attempt: PropTypes.object.isRequired
};

export default Attempt;
